<template>
  <div>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="8">
        <v-card max-width="100%" outlined>
          <v-toolbar short color="orange lighten-4" dense dark elevation="0" class="m-0 p-0">
            <v-toolbar-title class="m-0 pt-4">
              <p class="subtitle-2 text-center indigo--text font-weight-normal">
                <v-icon class="mx-2" color="indigo lighten">mdi-account</v-icon> Dados do
                Funcionário
              </p>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col
                  v-if="edit_enable"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  class="pb-0 mb-0"
                  color="red"
                >
                  <v-alert text outlined class="py-2" color="green" icon="mdi-table-edit">
                    A edição está habilitada
                  </v-alert>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">
                    Dados do Funcionário
                  </p>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-text-field
                    v-model.trim="$v.form.name.$model"
                    :disabled="!edit_enable"
                    type="text"
                    label="Nome"
                    outlined
                    dense
                    hide-details="auto"
                    :error-messages="errors.data.name"
                    @change="errorMensage('name')"
                    @blur="errorMensage('name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.surname.$model"
                    :disabled="!edit_enable"
                    type="text"
                    label="Sobrenome"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.surname"
                    @change="errorMensage('surname')"
                    @blur="errorMensage('surname')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="m-0 p-0">
                  <v-checkbox
                    v-model="have_social_name"
                    :disabled="!edit_enable"
                    label="Este funcionario possui um nome social?"
                    color="red lighten-1"
                    :style="{ fontWeight: 'bold' }"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" class="m-0 p-0">
                  <v-text-field
                    v-if="have_social_name"
                    v-model.trim="$v.form.social_name.$model"
                    :disabled="!edit_enable"
                    type="text"
                    label="Nome Social"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.social_name"
                    @change="errorMensage('social_name')"
                    @blur="errorMensage('social_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.gender.$model"
                    :disabled="!edit_enable"
                    :items="genders"
                    item-value="id"
                    item-text="gender"
                    label="Genero"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.gender"
                    @change="errorMensage('gender')"
                    @blur="errorMensage('gender')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.birthdate.$model"
                    :disabled="!edit_enable"
                    label="Data de Nascimento"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.birthdate"
                    @change="errorMensage('birthdate') | checkDate('birthdate')"
                    @blur="errorMensage('birthdate') | checkDate('birthdate')"
                    @keyup="checkDate('birthdate')"
                    @paste="checkDate('birthdate')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.cpf.$model"
                    v-mask="'###.###.###-##'"
                    :disabled="!edit_enable"
                    type="text"
                    label="CPF"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.cpf"
                    @change="errorMensage('cpf')"
                    @blur="errorMensage('cpf')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.rg.$model"
                    :disabled="!edit_enable"
                    type="number"
                    label="RG"
                    outlined
                    dense
                    class="m-0 p-0"
                    required
                    hide-details="auto"
                    :error-messages="errors.data.rg"
                    @change="errorMensage('rg')"
                    @blur="errorMensage('rg')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.email.$model"
                    :disabled="!edit_enable"
                    label="E-mail"
                    type="email"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.email"
                    @change="errorMensage('email')"
                    @blur="errorMensage('email')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.mobile_phone.$model"
                    v-mask="'(##)#########'"
                    :disabled="!edit_enable"
                    type="text"
                    label="Telefone"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.mobile_phone"
                    @change="errorMensage('mobile_phone')"
                    @blur="errorMensage('mobile_phone')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="m-0 p-0">
                  <v-select
                    v-model="$v.form.marital_status.$model"
                    :disabled="!edit_enable"
                    :items="marital_status"
                    item-text="status"
                    item-value="id"
                    dense
                    label="Estado Civil"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.marital_status"
                    @change="errorMensage('marital_status')"
                    @blur="errorMensage('marital_status')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.user_type.$model"
                    :disabled="!edit_enable"
                    :items="user_types"
                    item-text="type"
                    item-value="id"
                    dense
                    label="Tipo de Usuário"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.user_type"
                    @change="errorMensage('user_type')"
                    @blur="errorMensage('user_type')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-select
                    v-model.trim="$v.form.user_document_type.$model"
                    :disabled="!edit_enable"
                    :items="user_documents_types"
                    item-text="name"
                    item-value="id"
                    dense
                    label="Conselho"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.user_document_type"
                    @change="errorMensage('user_document_type')"
                    @blur="errorMensage('user_document_type')"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.user_document_number.$model"
                    :disabled="!edit_enable"
                    type="number"
                    label="Número do Documento"
                    outlined
                    dense
                    class="m-0 p-0"
                    required
                    hide-details="auto"
                    :error-messages="errors.data.user_document_number"
                    @change="errorMensage('user_document_number')"
                    @blur="errorMensage('user_document_number')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">
                    Endereço do Funcionário
                  </p>
                </v-col>
                <v-col cols="12" sm="10" md="6" lg="5">
                  <v-text-field
                    v-model.trim="$v.form.street_name.$model"
                    :disabled="!edit_enable"
                    label="Nome da Rua"
                    outlined
                    dense
                    hide-details="auto"
                    :error-messages="errors.data.street_name"
                    @change="errorMensage('street_name')"
                    @blur="errorMensage('street_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="3" lg="2" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.building_number.$model"
                    type="number"
                    :disabled="!edit_enable"
                    label="Número"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.building_number"
                    @change="errorMensage('building_number')"
                    @blur="errorMensage('building_number')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="2" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.post_code.$model"
                    v-mask="'#####-###'"
                    :disabled="!edit_enable"
                    label="CEP"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.post_code"
                    @change="errorMensage('post_code')"
                    @blur="errorMensage('post_code')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.complement.$model"
                    :disabled="!edit_enable"
                    label="Complemento"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.complement"
                    @change="errorMensage('complement')"
                    @blur="errorMensage('complement')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.state.$model"
                    :items="states"
                    item-value="id"
                    item-text="name"
                    label="Estado"
                    outlined
                    dense
                    :disabled="!edit_enable"
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.state"
                    @change="errorMensage('state') | setCurrentCitiesByState($event)"
                    @blur="errorMensage('state')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-if="cities != ''"
                    v-model.trim="$v.form.city.$model"
                    :items="cities"
                    item-value="id"
                    item-text="name"
                    label="Cidade"
                    outlined
                    dense
                    :disabled="!edit_enable"
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.city"
                    @change="errorMensage('city')"
                    @blur="errorMensage('city')"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-else
                    label="Cidade"
                    hide-details
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.neighborhood.$model"
                    :disabled="!edit_enable"
                    label="Bairro"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.neighborhood"
                    @change="errorMensage('neighborhood')"
                    @blur="errorMensage('neighborhood')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    hide-details
                    label="País"
                    value="Brasil"
                    outlined
                    dense
                    class="m-0 p-0"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pb-0 mb-0" color="red">
                  <p class="font-weight-black mb-0 pb-0 subtitle-1 text-red">Dados da Empresa</p>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    v-model.trim="$v.form.employee_registration.$model"
                    :disabled="!edit_enable"
                    label="Matricula"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.employee_registration"
                    @change="errorMensage('employee_registration')"
                    @blur="errorMensage('employee_registration')"
                    @keypress="validateEmployeeRegistration"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.employee_department.$model"
                    :items="departments"
                    item-value="id"
                    item-text="department"
                    dense
                    label="Setor"
                    outlined
                    class="m-0 p-0"
                    hide-details="auto"
                    :disabled="!edit_enable"
                    :error-messages="errors.data.employee_department"
                    @change="errorMensage('employee_department')"
                    @blur="errorMensage('employee_department')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model.trim="$v.form.employee_function.$model"
                    :items="functions"
                    item-value="id"
                    item-text="functions"
                    dense
                    label="Função"
                    outlined
                    class="m-0 p-0"
                    :disabled="!edit_enable"
                    hide-details="auto"
                    :error-messages="errors.data.employee_function"
                    @change="errorMensage('employee_function')"
                    @blur="errorMensage('employee_function')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="m-0 p-0">
                  <v-autocomplete
                    v-model="form.workstation"
                    :items="workstations"
                    item-value="id"
                    item-text="workstation"
                    dense
                    hide-details
                    :disabled="!edit_enable"
                    label="Vínculo"
                    outlined
                    class="m-0 p-0"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3" lg="3" class="m-0 p-0">
                  <v-text-field
                    :disabled="!edit_enable"
                    v-model.trim="$v.form.admission_date.$model"
                    label="Data da Admissão"
                    outlined
                    dense
                    class="m-0 p-0"
                    hide-details="auto"
                    :error-messages="errors.data.admission_date"
                    @change="errorMensage('admission_date') | checkDate('admission_date')"
                    @blur="errorMensage('admission_date') | checkDate('admission_date')"
                    @keyup="checkDate('admission_date')"
                    @paste="checkDate('admission_date')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-4 py-0 mb-4 d-flex justify-end">
            <v-btn
              v-if="!edit_enable"
              @click="edit_enable = true"
              dark
              large
              color="yellow darken-2"
              elevation="0"
              >Editar</v-btn
            >
            <v-btn
              v-if="edit_enable"
              @click="cancelEdit()"
              dark
              large
              color="red darken-2"
              elevation="0"
              >Cancelar</v-btn
            >
            <v-btn
              v-if="edit_enable"
              @click="updateEmployee"
              dark
              large
              color="green darken-2"
              elevation="0"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="4">
        <v-card max-width="100%" class="mb-4" outlined>
          <v-toolbar short color="grey lighten-1" dense dark elevation="0" class="m-0 p-0">
            <v-toolbar-title class="m-0 pt-4">
              <p class="subtitle-2 text-center black--text font-weight-normal">
                <v-icon class="mx-2" color="black lighten">mdi-account-details</v-icon>
                Contracheques do Funcionário
              </p>
            </v-toolbar-title>
          </v-toolbar>
          <v-list three-line>
            <template v-for="(item, index) in items">
              <v-subheader v-if="item.header" :key="item.header" v-text="item.header"></v-subheader>
              <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>
              <v-list-item v-else :key="item.title">
                <v-list-item-content>
                  <v-list-item-title v-html="item.title"></v-list-item-title>
                  <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" class="mt-4">
        <v-card max-width="100%" outlined>
          <v-toolbar short color="grey lighten-1" dense dark elevation="0" class="m-0 p-0">
            <v-toolbar-title class="m-0 pt-4">
              <p class="subtitle-2 text-center black--text font-weight-normal">
                <v-icon class="cancelEditx-2" color="black lighten">mdi-account-details</v-icon>
                Autorizações do Funcionário
              </p>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-select
                v-model.trim="form.authorizations"
                :disabled="!edit_authorizations"
                :items="authorizations"
                item-value="id"
                item-text="type"
                label="Autorizações"
                outlined
                dense
                multiple
                class="m-0 p-0"
              >
                <template v-slot:selection="{ item, index }">
                  <template v-if="index === 0">
                    <span>{{ item.type }}</span>
                  </template>

                  <span v-if="index === 1" class="grey--text caption">
                    (+{{ form.authorizations.length - 1 }} outros)
                  </span>
                </template>
              </v-select>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-4 py-0 mb-4 d-flex justify-end">
            <v-btn
              v-if="!edit_authorizations"
              dark
              large
              color="yellow darken-2"
              elevation="0"
              @click="edit_authorizations = true"
              >Editar</v-btn
            >
            <v-btn
              v-if="edit_authorizations"
              dark
              large
              color="green darken-2"
              elevation="0"
              @click="updateAuthorizations()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" class="mt-4">
        <v-card max-width="100%" outlined>
          <v-toolbar short color="grey lighten-1" dense dark elevation="0" class="m-0 p-0">
            <v-toolbar-title class="m-0 pt-4">
              <p class="subtitle-2 text-center black--text font-weight-normal">
                <v-icon class="mx-2" color="black lighten">mdi-account-details</v-icon>
                Status do Funcionário
              </p>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-select
                v-model.trim="form.status"
                :items="status"
                :disabled="!edit_status"
                item-value="id"
                item-text="status"
                label="Status"
                dense
                outlined
              >
              </v-select>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-4 py-0 mb-4 d-flex justify-end">
            <v-btn
              v-if="!edit_status"
              dark
              large
              color="yellow darken-2"
              elevation="0"
              @click="edit_status = true"
              >Editar</v-btn
            >
            <v-btn
              v-if="edit_status"
              dark
              large
              color="green darken-2"
              elevation="0"
              @click="updateStatus()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
export default {
  name: 'ShowEmployee',
  directives: { mask },
  data: function () {
    return {
      items: [
        { header: 'Últimos contracheques inseridos' },
        { divider: true, inset: true },
        {
          title: 'Junho - <span class="grey--text text--lighten-1">2020</span>',
          subtitle:
            "<span class='text--primary'>Contracheque inserido em 04/06/2020</span><br>Baixado pelo usuário em: ",
        },
      ],
      Pesquisar: '',
      gender: '',
      // employees_data: [],
      // states: [],
      // cities: [],
      have_social_name: false,
      total_salary: '',
      edit_enable: false,
      edit_permissions: false,
      edit_status: false,
      edit_authorizations: false,
      form: {
        name: '',
        surname: '',
        birthdate: '',
        cpf: '',
        rg: '',
        social_name: '',
        gender: '',
        email: '',
        mobile_phone: '',
        marital_status: '',
        street_name: '',
        building_number: '',
        post_code: '',
        complement: '',
        state: '',
        city: '',
        neighborhood: '',
        employee_registration: '',
        employee_department: '',
        employee_function: '',
        admission_date: '',
        authorizations: '',
        permissions: '',
        status: [],
        workstation: '',
        user_type: '',
        user_document_type: '',
        user_document_number: '',
      },
      errors: {
        messages: {
          required: 'O campo e obrigatorio',
          minLength: (num) => `O campo deve ter no minimo ${num} caracteres`,
          email: 'Email invalido',
          maxLength: (num) => `O campo deve ter no maximo ${num} caracteres`,
        },
        data: {
          name: [],
          surname: [],
          birthdate: [],
          cpf: [],
          rg: [],
          social_name: [],
          gender: [],
          email: [],
          mobile_phone: [],
          marital_status: [],
          street_name: [],
          building_number: [],
          post_code: [],
          complement: [],
          state: [],
          city: [],
          neighborhood: [],
          employee_registration: [],
          employee_department: [],
          employee_function: [],
          admission_date: [],
          authorizations: [],
          permissions: [],
          user_type: [],
          user_document_type: [],
          user_document_number: [],
        },
      },
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      surname: {
        required,
        minLength: minLength(4),
      },
      birthdate: {
        required,
        minLength: minLength(10),
      },
      cpf: {
        required,
        minLength: minLength(14),
        maxLength: maxLength(14),
      },
      rg: {
        required,
        minLength: minLength(4),
      },
      social_name: {},
      gender: {
        required,
      },
      email: {
        required,
        email,
      },
      mobile_phone: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(13),
      },
      marital_status: {
        required,
      },
      street_name: {
        required,
      },
      building_number: {
        required,
      },
      post_code: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      complement: {},
      state: {
        required,
      },
      city: {
        required,
      },
      neighborhood: {
        required,
        minLength: minLength(2),
      },
      employee_registration: {
        required,
      },
      employee_department: {
        required,
      },
      employee_function: {
        required,
      },
      admission_date: {
        required,
        minLength: minLength(10),
      },
      authorizations: {
        required,
      },
      permissions: {},
      user_type: {
        required,
      },
      user_document_type: {},
      user_document_number: {},
    },
  },
  computed: {
    ...mapState('employees', ['employees']),
    ...mapState('utils', [
      'states',
      'marital_status',
      'roles',
      'departments',
      'functions',
      'genders',
      'authorizations',
      'permissions',
      'status',
      'workstations',
      'user_types',
      'user_documents_types',
      'cities',
    ]),
  },
  beforeMount() {
    if (!this.$router.currentRoute.params.employee_id) {
      window.addEventListener('beforeunload', this.$router.push('/home'))
    }
  },
  created() {
    let employee = this.getEmployee(this.$router.currentRoute.params.employee_id)
    let { birthdate, admission_date } = employee
    birthdate = this.formatStringDataToReceive(birthdate)
    admission_date = this.formatStringDataToReceive(admission_date)
    this.form = { ...employee, birthdate, admission_date }
    this.checkSocialName()
    this.setCurrentCitiesByState(this.form.state)
    this.totalSalary()
  },
  methods: {
    ...mapActions('utils', ['setCurrentCitiesByState']),
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('employees', [
      'ActionUpdateEmployee',
      'ActionUpdatePermissions',
      'ActionUpdateAuthorizations',
      'ActionUpdateStatus',
    ]),
    checkSocialName() {
      const full_name = this.form.name + ' ' + this.form.surname
      if (this.form.social_name != full_name) {
        this.have_social_name = true
      } else {
        this.form.social_name = ''
      }
    },
    cancelEdit() {
      let employee = this.getEmployee(this.$router.currentRoute.params.employee_id)
      let { birthdate, admission_date } = employee
      birthdate = this.formatStringDataToReceive(birthdate)
      admission_date = this.formatStringDataToReceive(admission_date)
      this.form = { ...employee, birthdate, admission_date }
      this.edit_enable = false
    },
    formatStringDataToSend(data) {
      let dia = data.split('/')[0]
      let mes = data.split('/')[1]
      let ano = data.split('/')[2]
      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2)
    },
    formatStringDataToReceive(data) {
      let dia = data.split('-')[2]
      let mes = data.split('-')[1]
      let ano = data.split('-')[0]
      return ('0' + dia).slice(-2) + '/' + ('0' + mes).slice(-2) + '/' + ano
    },
    async updateEmployee() {
      this.ActionSetLoading(true)

      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })

        if (!this.$v.$invalid) {
          let birthdate = this.formatStringDataToSend(this.form.birthdate)
          let admission_date = this.formatStringDataToSend(this.form.admission_date)
          await this.ActionUpdateEmployee({ ...this.form, birthdate, admission_date })
          this.edit_enable = false
          this.$swal({
            icon: 'success',
            title: 'Atualizado!',
            text: 'Funcionário atualizado com sucesso.',
          })
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }
      this.ActionSetLoading(false)
    },
    getEmployee: function (employee_id) {
      const employee = this.employees.data.find(function (emp) {
        if (emp.id == employee_id) {
          return emp
        } else {
          return false
        }
      })
      return employee
    },
    totalSalary: function () {
      let dangerous = this.form.dangerousness ? this.form.dangerousness : 0
      let baseSalary = this.form.salary ? this.form.salary : 0
      let gratifications = this.form.gratification ? this.form.gratification : 0
      let unhealthy = this.form.unhealthy ? this.form.unhealthy : 0
      this.total_salary = (
        parseFloat(dangerous) +
        parseFloat(baseSalary) +
        parseFloat(gratifications) +
        parseFloat(unhealthy)
      ).toFixed(2)
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
    checkDate(key) {
      this.form[key] = this.form[key].replace(/\s/g, '')
      let v = this.form[key]
      if (this.form[key].length == 2 || this.form[key].length == 5) {
        if (v.substring(v.length - 1, v.length - 1) !== '/') this.form[key] = this.form[key] + '/'
      } else if (this.form[key].length > 10) {
        this.form[key] = this.form[key] - 1
      }
      if (v.length > 10) {
        this.form[key] = v.substring(0, 9)
      } else if (v.length == 10) {
        const dateReg = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
        if (!this.form[key].match(dateReg)) {
          this.errors.data[key] = ['Data invalida']
        } else {
          this.errors.data[key] = []
        }
      }
    },
    async updatePermission() {
      this.ActionSetLoading(true)
      try {
        await this.ActionUpdatePermissions({
          user_id: this.form.id,
          permissions: this.form.permissions,
        })
        this.$swal({
          icon: 'success',
          title: 'Atualizado!',
          text: 'Funcionário atualizado com sucesso.',
        })
        this.edit_permissions = false
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao atualizar permissoes do usuario',
        })
      }
      this.ActionSetLoading(false)
    },
    async updateAuthorizations() {
      this.ActionSetLoading(true)
      try {
        this.ActionSetLoading(true)
        await this.ActionUpdateAuthorizations({
          user_id: this.form.id,
          authorizations: this.form.authorizations,
        })
        this.$swal({
          icon: 'success',
          title: 'Atualizado!',
          text: 'Funcionário atualizado com sucesso.',
        })
        this.edit_authorizations = false
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao atualizar autorizacoes do usuario',
        })
      }
      this.ActionSetLoading(false)
    },
    async updateStatus() {
      this.ActionSetLoading(true)
      try {
        this.ActionSetLoading(true)
        await this.ActionUpdateStatus({
          user_id: this.form.id,
          status: this.form.status,
        })
        this.$swal({
          icon: 'success',
          title: 'Atualizado!',
          text: 'Funcionário atualizado com sucesso.',
        })
        this.edit_status = false
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao atualizar o status do usuario',
        })
      }
      this.ActionSetLoading(false)
    },
    validateEmployeeRegistration($event) {
      const validChar = new RegExp(/^[xX0-9]+$/)
      if (!validChar.test($event.key)) {
        $event.preventDefault()
      }
    },
  },
}
</script>
